export default class CustomerAddressForm extends Core.Component {
  constructor(el, context) {
    super(el, context);

    this.countryContainer = el.querySelector('[data-address-form-country]');
    this.countrySelect = this.countryContainer.querySelector('select');
    this.provinceContainer = el.querySelector('[data-address-form-province]');
    this.provinceSelect = this.provinceContainer.querySelector('select');

    this.countryProvinceObserver = new Shopify.CountryProvinceSelector(
      this.countrySelect.id,
      this.provinceSelect.id,
      {
        hideElement: this.provinceContainer.id,
      },
    );
  }

  onMount() {
    const editButton = this.query('button', 'edit-address');
    const deleteButton = this.query('button', 'delete-address');
    const resetButton = this.query('button', 'reset-address');

    Core.Events.register(editButton.el, 'click', e => {
      this.toggleEditForm(e);
    });
    Core.Events.register(resetButton.el, 'click', e => this.toggleEditForm(e));

    if (deleteButton) {
      Core.Events.register(deleteButton.el, 'click', e => this.handleDeleteClick(e));
    }
  }

  toggleEditForm({ currentTarget }) {
    const addressForm = this.el.querySelector('[data-edit-address-modal]');
    const open = addressForm.dataset.open === 'true';
    addressForm.setAttribute('data-open', open ? 'false' : 'true');
    currentTarget.setAttribute('aria-expanded', open ? 'false' : 'true');
  }

  handleDeleteClick({ currentTarget }) {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute('data-confirm-message'))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  }
}
